import {
  Alert,
  Box,
  Spinner,
  Text,
  WizardStepRenderParams,
} from '@factorialco/deprecated-design-system'
import {
  ItManagementSoftwareItemFragment,
  SoftwareWizardSoftwareStepDocument,
} from 'generated/resources/graphql'

import { useEffect } from 'modules/core/hooks/useEffect'
import { useQuery } from 'modules/core/hooks/useQuery'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import type { WizardData } from '../types'
import SoftwareSelector from './SoftwareSelector'

export const SoftwareStep = ({ data, onDataChanged }: WizardStepRenderParams<WizardData>) => {
  const { softwareId, softwareName } = data

  const { loading, data: queryData } = useQuery(SoftwareWizardSoftwareStepDocument)

  const customSoftwares = queryData?.itManagement?.customSoftwares || []
  const softwareSetups = queryData?.itManagement?.softwareSetups || []
  const softwares = queryData?.itManagement?.softwares || []

  const allSoftware = [
    ...softwares.map((s: ItManagementSoftwareItemFragment) => ({
      id: s.id,
      name: s.name,
      logoUrl: s.logoUrl,
    })),
    ...customSoftwares,
  ]

  const selectSoftware = (id: string) => {
    onDataChanged({ ...data, softwareId: id, softwareName: undefined })
  }
  const selectCustomSoftware = (id: string) => {
    onDataChanged({ ...data, softwareId: undefined, softwareName: id })
  }

  useEffect(() => {
    track(trackingEvents.itManagement.goToSoftwareSetupWizardStep, {
      step: 1,
    })
  }, [])

  return (
    <Box gap="s64" flexDirection="row">
      <Box gap="s24" width="full">
        <Box gap="s8">
          <Text.Header2>
            {i18n.t('it_management.initial_setup.wizard.steps.software.title')}
          </Text.Header2>

          <Text.Normal>
            {i18n.t('it_management.initial_setup.wizard.steps.software.description')}
          </Text.Normal>
        </Box>

        <Box gap="s8" maxWidth="s600">
          {loading ? (
            <Box alignItems="center">
              <Spinner />
            </Box>
          ) : (
            <Box gap="s8">
              <Text.Normal>
                {i18n.t('it_management.initial_setup.wizard.software_selector.label')}
              </Text.Normal>
              <SoftwareSelector
                selectSoftware={selectSoftware}
                selectCustomSoftware={selectCustomSoftware}
                softwares={allSoftware}
                softwareSetups={softwareSetups}
                softwareId={softwareId!}
                softwareName={softwareName || ''}
              />
            </Box>
          )}
        </Box>
      </Box>

      <Box width="s600">
        <Alert color="info">
          <Text.Normal>
            {i18n.t('it_management.initial_setup.wizard.alerts.start_info')}
          </Text.Normal>
        </Alert>
      </Box>
    </Box>
  )
}
